(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.height = this.header.clientHeight;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
  }

  disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
      });

      observer.observe(this.header);
  }

  onScroll() {
      this.header.classList.add('sticky-header');
  }

  hide() {
      this.closeMenuDisclosure();
  }

  reveal() {
      this.header.closest('.shopify-section-group-header-group').classList.add('shopify-section-header-sticky', 'animate');
      this.header.closest('.shopify-section-group-header-group').classList.remove('shopify-section-header-hidden');
  }

  reset() {
      this.header.closest('.shopify-section-group-header-group').classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
  }

}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
      super();
  }

  connectedCallback() {
      this.header = document.querySelector('.header-section');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.height = this.header.clientHeight;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
  }

  disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
      });

      observer.observe(this.header);
  }

  onScroll() {
      this.header.classList.add('sticky-header');
  }

  hide() {
      this.closeMenuDisclosure();
  }

  reveal() {
      this.header.closest('.shopify-section-group-header-group').classList.add('shopify-section-header-sticky', 'animate');
      this.header.closest('.shopify-section-group-header-group').classList.remove('shopify-section-header-hidden');
  }

  reset() {
      this.header.closest('.shopify-section-group-header-group').classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
  }

}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  document.addEventListener("DOMContentLoaded", function() {
    observer.observe(productRecommendationsSection);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            animateElements();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
